import React, { useState } from "react";


const departments = [
    { "name": "संगणक प्रयोगशाला के बारे में", "id": "about" },
    { "name": "संगणक प्रयोगशाला के नियम", "id": "rules" }
];

const departmentContent = {
    "about": (
        <div>
            <h5
                className="mb-3"
                style={{ color: '#77236b', textAlign: 'center' }}
            >संगणक प्रयोगशाला </h5>
            <p className="mb-2 text-justify">विश्वविद्यालय में कम्प्यूटर प्रयोगशाला उपलब्ध हैं, जिसमें 30 आधुनिक कम्प्यूटर स्थित हैं। प्रयोगशाला में छात्रों को पाठ्यक्रम के अनुसार अध्ययन के साथ-साथ संस्कृत एवं हिन्दी भाषा में टाईपिंग भी सिखाई जाती है। जिसका लाभ डिप्लोमा, शास्त्री, आचार्य एवं विद्यावारिधि के छात्रों को भरपूर हो रहा है। विश्वविद्यालय की इस संगणक प्रयोगशाला में अन्तर्जाल (Internet) की सुविधा सभी छात्रों के लिए उपलब्ध है।</p>
        </div>
    ),
    "rules": (
        <div>
            <h5
                className="mb-3"
                style={{ color: '#77236b', textAlign: 'center' }}
            >संगणक प्रयोगशाला के नियम</h5>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0 text-justify">• उपयोगकर्ताओं को कंप्यूटर पर किसी भी कॉपीराइट संरक्षित सामग्री या जानकारी को डाउनलोड करने या अवैध प्रतियाँ (जैसे सॉफ्टवेयर, संगीत, वीडियो, किताबें, फोटोग्राफी आदि) बनाने की अनुमति नहीं है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• जान-बूझकर उपकरणों को भौतिक तरीकों से या ऐसे प्रोग्रामों के माध्यम से नष्ट या क्षतिग्रस्त नहीं करेंगे जो उपकरण या सॉफ्टवेयर को नुकसान पहुँचा सकते हैं।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• उपयोगकर्ता संगणक ऐसे उपयोग के लिए विभाग से पूर्व अनुमति प्राप्त किए बिना व्यावसायिक उद्देश्यों या वित्तीय लाभ के लिए विश्वविद्यालय के कम्प्यूटरों का उपयोग नहीं कर सकते।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• लैब में गेम खेलने, फेसबुक एवं अन्य सोशल मीडिया सम्बन्धी वीडियो, चैटिंग और यूट्यूब आदि पर फिल्में देखने की अनुमति नहीं है। लैब में कम्प्यूटर का उपयोग केवल शैक्षणिक उद्देश्यों के लिए किया जाएगा, मनोरंजन के लिए नहीं।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• प्रयोगशाला में भोजन, पेय या किसी भी रूप में तम्बाकू के उपयोग की अनुमति नहीं है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• प्रयोगशाला में गतिविधियों के निरीक्षण के लिए लैब अटेंडेंट के साथ सहयोग करेंगे। अधिकृत अधिकारियों द्वारा माँगे जाने पर छात्रों को अपना आईडी कार्ड दिखाना होगा। बिना पहचान-पत्र के कम्प्यूटर प्रयोगशाला में प्रवेश वर्जित है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• कम्प्यूटर लैब में उपलब्ध सॉफ्टवेयर और ऑपरेटिंग सिस्टम शैक्षणिक आवश्यकताओं के अनुसार प्रदान किए जाते हैं। सॉफ़्टवेयर में परिवर्तन केवल विश्वविद्यालय द्वारा छात्रों के अनुरोध पर विश्वविद्यालय के संकाय सदस्यों द्वारा अनुशंसित और विश्वविद्यालय के डीन द्वारा अनुमोदित और लाइसेंस की उपलब्धता के अनुसार किया जाता है। पहले से इंस्टॉल किए गए सॉफ़्टवेयर के अतिरिक्त अन्य सॉफ़्टवेयर इंस्टॉल करने का प्रयास या मौजूदा कॉन्फ़िगरेशन में संशोधन की अनुमति नहीं है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• विश्वविद्यालय कम्प्यूटर वायरस या उपकरण के अनुचित उपयोग या किसी अन्य कारण से डेटा की हानि के लिए जिम्मेदार नहीं है। छात्रों को नियमित अन्तराल पर महत्वपूर्ण डेटा बैकअप रखने की सलाह दी जाती है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• हार्डवेयर की शिफ्टिंग/स्वैपिंग सख्त वर्जित है।</li>
                <li className="list-group-item bg-transparent border-0 text-justify">• कम्प्यूटर लैब में छात्रों को व्यक्तिगत लैपटॉप की अनुमति नहीं है। व्यक्तिगत लैपटॉप या इलेक्ट्रॉनिक वस्तुओं की किसी भी क्षति या हानि के लिए विश्वविद्यालय प्रशासन को जिम्मेदार नहीं ठहराया जाएगा।</li>
            </ul>
        </div>
    )
};

export default function ComputerLab() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about");

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        setShowSidebar(false);
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>


            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">संगणक प्रयोगशाला</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeContentId === dept.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : "", // Apply the color when active
                            }}
                            onClick={() => handleItemClick(dept.id)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" onClick={() => setShowSidebar(false)}>
                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>
        </div>
    );
}
